import Vue from 'vue'
import VueRouter from 'vue-router'
import Step from "./views/Step"
import Finish from "./views/Finish"


Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        name: 'step',
        component: Step
    },
    {
        path: '/lang_test',
        name: 'start',
        component: Step
    },
    {
        path: '/lang_test/finish',
        name: 'finish',
        component: Finish
    },
]

const router = new VueRouter({
    mode: 'history',
    base: window.lang_test_base_url,
    routes
})

export default router
